'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useExperienceFilterContext } from '../_components/app-experience-filter-provider';
import { EXPERIENCE_AVAILABILITY_STALE_TIME, EXPERIENCE_TIMESLOTS_INITIAL_PAGE_PARAM, fetchExperienceTimeslotsPageClient, getExperienceTimeslotsBaseVariables, getExperienceTimeslotsQueryKey, getNextExperienceTimeslotsPageParam } from '../_lib/experience-availability-query';
import { useExperiencePreviewToken } from './use-experience-preview-token';
export function useAppExperienceTimeslots() {
  const $ = _c(26);
  const {
    experience,
    filter: experienceFilter
  } = useExperienceFilterContext();
  const previewToken = useExperiencePreviewToken();
  let t0;
  if ($[0] !== experience.publicId || $[1] !== experienceFilter || $[2] !== previewToken) {
    t0 = getExperienceTimeslotsBaseVariables({
      publicId: experience.publicId,
      previewToken,
      filter: experienceFilter
    });
    $[0] = experience.publicId;
    $[1] = experienceFilter;
    $[2] = previewToken;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const baseVariables = t0;
  let t1;
  if ($[4] !== experience.publicId || $[5] !== experienceFilter || $[6] !== previewToken) {
    t1 = getExperienceTimeslotsQueryKey({
      publicId: experience.publicId,
      previewToken,
      filter: experienceFilter
    });
    $[4] = experience.publicId;
    $[5] = experienceFilter;
    $[6] = previewToken;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const queryKey = t1;
  const t2 = !!experienceFilter.selectedVariant;
  let t3;
  if ($[8] !== baseVariables) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      return fetchExperienceTimeslotsPageClient({
        ...baseVariables,
        pagination: pageParam
      });
    };
    $[8] = baseVariables;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== queryKey || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      enabled: t2,
      queryKey,
      queryFn: t3,
      initialPageParam: EXPERIENCE_TIMESLOTS_INITIAL_PAGE_PARAM,
      placeholderData: keepPreviousData,
      getNextPageParam: getNextExperienceTimeslotsPageParam,
      staleTime: EXPERIENCE_AVAILABILITY_STALE_TIME
    };
    $[10] = queryKey;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isPending,
    isFetching,
    isPlaceholderData
  } = useInfiniteQuery(t4);
  let t5;
  let t6;
  if ($[14] !== data?.pages) {
    t6 = data?.pages || [];
    $[14] = data?.pages;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = t6.flatMap(_temp);
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  t5 = t7;
  const dates = t5;
  let t8;
  if ($[18] !== dates || $[19] !== fetchNextPage || $[20] !== hasNextPage || $[21] !== isFetching || $[22] !== isLoading || $[23] !== isPending || $[24] !== isPlaceholderData) {
    t8 = {
      dates,
      canFetchMore: hasNextPage,
      fetchMore: fetchNextPage,
      isLoading,
      isPending,
      isFetching,
      isPlaceholderData
    };
    $[18] = dates;
    $[19] = fetchNextPage;
    $[20] = hasNextPage;
    $[21] = isFetching;
    $[22] = isLoading;
    $[23] = isPending;
    $[24] = isPlaceholderData;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}
function _temp(t0) {
  const {
    nexperienceAvailableDates
  } = t0;
  return nexperienceAvailableDates.dates;
}